export default "__VITE_ASSET__BlTr2zcG__"